import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useAppUpdateBlockingStore = defineStore("app-update-blocking", () => {
  const dirtyFormIds = ref(new Set<string>());

  function setDirtyFormActive(id: string, active: boolean) {
    const next = new Set(dirtyFormIds.value);
    if (active) {
      next.add(id);
    } else {
      next.delete(id);
    }
    dirtyFormIds.value = next;
  }

  const hasDirtyFormBlockingRefresh = computed(() => dirtyFormIds.value.size > 0);

  return {
    setDirtyFormActive,
    hasDirtyFormBlockingRefresh,
  };
});
